export const toFiLocaleTwoDecimals = (n: number | undefined | null) =>
  n || n === 0
    ? n.toLocaleString("fi", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : n;

const toLocaleNoDecimals = (n: number | undefined | null, language: string) =>
  n || n === 0
    ? n.toLocaleString(language, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
    : n;

export const toPercentage = (decimalStr: string, maxDecimals = 1): string => {
  const num = parseFloat(decimalStr);
  if (isNaN(num)) return "";

  const percentage = num * 100;
  return Number.isInteger(percentage)
    ? percentage.toString()
    : percentage.toFixed(maxDecimals).replace(".", ",");
};

export const euroSum = (n: number | undefined | null) =>
  n && Number.isFinite(n) ? toLocaleNoDecimals(n, "fi") : "-";
export const euroSumOrZero = (n: number | undefined | null) =>
  (n || n === 0) && Number.isFinite(n) ? toLocaleNoDecimals(n, "fi") : "-";
//export const euroSum = (language: String, n: number | undefined | null) => n ? toLocaleNoDecimals(n, "fi") : "-";
export const localeEuroSumOrZero = (
  language: string,
  n: number | undefined | null,
) => (n || n === 0 ? toLocaleNoDecimals(n, language) : "-");

/**
 * Rounds a number to the nearest integer, can be used for UI and test output.
 * Used only for display or comparison, not in core calculations.
 */
export const roundToInt = (value: number): number => {
  return Math.round(value);
};
